export default __webpack_public_path__ + "static/media/materialdesignicons-webfont.d4de1856.svg";